module.exports = __webpack_public_path__ + "img/remove-profile-img.b061e0d6.svg";